import { render, staticRenderFns } from "./MKBSearch.vue?vue&type=template&id=4861f73e&scoped=true"
import script from "./MKBSearch.vue?vue&type=script&lang=js"
export * from "./MKBSearch.vue?vue&type=script&lang=js"
import style0 from "./MKBSearch.vue?vue&type=style&index=0&id=4861f73e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4861f73e",
  null
  
)

export default component.exports